import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { useScopedAppFlagStore } from '@frontend/scope';

export const useGetTaskCenterCustomizationFlagValue = () => {
  const { getCustomizationFlagValue, getCustomizationFlagLocationMap } = useScopedAppFlagStore();
  const isTaskCenterEnabled = getCustomizationFlagValue(Feature.TASK_CENTER);

  const getFlagByLocation = (locationId: string) => {
    const locationFlagMap = getCustomizationFlagLocationMap(Feature.TASK_CENTER);
    return locationFlagMap[locationId]?.state === State.ACTIVE || false;
  };

  return { isTaskCenterEnabled, getFlagByLocation };
};
